<template>
  <app-name-place
    v-if="data.visible === 'true'"
    :name="data.title"
    :position="{x: position.x, y: position.y + 5, z: position.z}"
    :isActive="!isFocused"
    :lookAt="{x: cameraPos.x, y: cameraPos.y, z: cameraPos.z}"
    @click="$emit('click')"
  />
    <!-- :lookAt="{x: cameraPos.x, y: position.y, z: cameraPos.z}" -->
</template>

<script>
import { Vector3, Quaternion, Vector2 } from 'three'
import gsap from 'gsap'

import { District } from '@/webGL/objects/District'
import { Fader } from '@/webGL/objects/Fader'
import { webGL } from '@/webGL/WebGL'
import { FitTo } from '@/utils/FitTo'
import { neon } from '@/webGL/objects/Neon'
import { Particles } from '@/webGL/objects/Particles'

import AppNamePlace from '@/components/AppNamePlace'

export default {

  components: {
    AppNamePlace
  },

  data () {
    return {
      position: new Vector3()
    }
  },

  props: {
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: () => {return {}}
    },
    isActive: {
      type: Boolean,
      default :false
    },
    cameraPos: {
      type: Object,
      default: {x: 0, y:0, z:0}
    },
    isFocused: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isClickable () {
      return this.$route.name.includes('city')
    }
  },

  created () {
    this.district = new District(this.data.url)
    this.isHover = false
    this.fitTo = new FitTo(webGL.camera)

    webGL.scene.add(this.district)

    this.district.promise.then(() => {
      this.getPosition()
      this.addParticles()
      this.$emit('loaded')
    })

    this.zonings = []

    this.$hub.on('3d:loaded', this.onFullLoaded)
    this.isPause = false
  },

  mounted () {
    this.$hub.on('mainScene:pause', () => {
      this.isPause = true
    })
    this.$hub.on('mainScene:start', () => {
      this.isPause = false
    })
  },

  methods: {
    onFullLoaded () {
      webGL.scene.updateMatrixWorld()

      neon.addToLayer({ name: this.data.totem })
      this.totem = this.district.getObjectByName(this.data.totem)

      this.convertZoning()
    },

    addParticles () {
      const box = this.district.boundingBox.expandByVector(new Vector3(0, 100, 0))
      box.translate(new Vector3(0, -box.min.y, 0))

      this.particles = new Particles({particleSize: 1, size: box, speed: new Vector2(0, 10)})

      webGL.scene.add(this.particles)
    },

    onResize () {
      this.getPosition()
    },

    onUpdate (time) {
      if (this.isPause) { return }

      if (this.isClickable && this.data.visible === 'true') {
        const isHover = this.$device.getIntersectPosition(this.district) !== null

        if (isHover !== this.isHover) {
          if (isHover) {
            this.$emit('hover')
          }
          else {
            this.$emit('out')
          }
        }
        this.isHover = isHover
      }

      if (this.particles) {
        this.particles.update(time)
      }
    },

    convertZoning () {
      this.data.zoning.forEach((name, i) => {
        let baseZoning = webGL.scene.getObjectByName(name)
        if (!baseZoning) {return}
        baseZoning.visible = false

        this.zonings[i] = new Fader(baseZoning.geometry)

        const position = new Vector3()
        const quaternion = new Quaternion()
        const scale = new Vector3()

        baseZoning.matrixWorld.decompose( position, quaternion, scale )
        this.zonings[i].position.copy(position)
        this.zonings[i].quaternion.copy(quaternion)
        this.zonings[i].scale.copy(scale)

        if (this.data.visible === 'true') {
          webGL.scene.add(this.zonings[i])
        }
      })
    },

    getPosition () {
      const fitTo = this.fitTo.fit(this.district.boundingBox, this.$device.isMobile ? 0 : .3, {
        vector: new Vector3(this.data.lookVector.x, this.data.lookVector.y, this.data.lookVector.z)
      })
      const fitToDistrict = this.fitTo.fit(this.district.boundingBox, {top: .1, right: .5, left: 0, bottom: .1}, {
        vector: new Vector3(this.data.lookVector.x, this.data.lookVector.y, this.data.lookVector.z)
      })

      this.position.copy(fitTo.look)

      this.$store.commit('data/districtCamera', {
        index: this.index,
        cameraPos: fitTo.position,
        look: fitTo.look,
        cameraPosDistrict: fitToDistrict.position,
        lookDistrict: fitToDistrict.look
      })
    }
  },

  watch: {
    isFocused () {
      if (this.isFocused) {
        this.zonings.forEach(zoning => {
          gsap.to(zoning, {
            threshold: 0,
            duration: 3
          })
        })
      }
      else {
        this.zonings.forEach(zoning => {
          gsap.to(zoning, {
            threshold: 1,
            duration: 3
          })
        })
      }
    }
  }
}
</script>